import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import NavBar from "./NavBar";
import Footer from "./Footer";
import InputAdd from "../components/Inputs/InputAdd";
import axios from "axios";
import Loading from "./Loading";
import { LoaderCircle } from "lucide-react";

export default function AdicionarClientes() {
  const { id } = useParams();
  const [nome, setNome] = useState("");
  const [contacto, setContacto] = useState("");
  const [endereco, setEndereco] = useState("");
  const [nuit, setNuit] = useState("");
  const [data, setData] = useState("");
  const [colaborador, setColaborador] = useState("");
  const [cadastrado, setCadastrado] = useState(false);
  const [loading, setLoading] = useState(false);
  const [mensagem, setMensagem] = useState("");
  const [usuario, setUsuario] = useState("");
  const [cadastrando, setCadastrando] = useState(false);
  const navigate = useNavigate();
  //hello world

  async function verificarDetalhesDoCliente() {
    setLoading(true);
    try {
      const token = JSON.parse(localStorage.getItem("token"))
      const response = await axios.get(`https://api-eyazs-production-8f74.up.railway.app/detalheusuario/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,  // Exemplo de cabeçalho com token de autorização
          'Content-Type': 'application/json'        // Exemplo de cabeçalho para tipo de conteúdo
        }
      });
      if (response.data.detalhe) {
        setCadastrado(true);
        setUsuario(response.data.detalhe.nome)
        console.log("Detalhes do usuário:", response);
      } else {
        setCadastrado(false);
        console.log("nao ha dados!");
      }
    } catch (erro) {
      if (erro.response?.status === 404) {
        setCadastrado(false);
      } else {
        console.error("Erro ao verificar detalhes do cliente:", erro);
      }
    } finally {
      setLoading(false);
    }
  }
  

  async function adicionarDadosCliente() {
    if (!nome || !contacto || !endereco || !data || !colaborador) {
      setMensagem("Por favor, preencha todos os campos obrigatórios.");
      return;
    }
    try {
      setCadastrando(true);
      const token = JSON.parse(localStorage.getItem("token"))
      const response = await axios.post(
        "https://api-eyazs-production-8f74.up.railway.app/detalhe",
        {
          headers: {
            'Authorization': `Bearer ${token}`,  // Exemplo de cabeçalho com token de autorização
            'Content-Type': 'application/json'        // Exemplo de cabeçalho para tipo de conteúdo
          }
        },
        {
          idUsuario: id,
          nome: nome,
          contacto:contacto,
          dataSubscricao: data,
          endereco:endereco,
          nuit:nuit,
          colaboradorAssociado: colaborador,
        }
      );
      if (response.status === 201 || response.data) {
        alert("Cliente cadastrado com sucesso!");
        setCadastrado(true);
      }
    } catch (erro) {
      console.error("Erro ao cadastrar cliente:", erro);
      setMensagem("Erro ao cadastrar cliente. Tente novamente.");
    } finally {
      setCadastrando(false);
    }
  }

  useEffect(() => {
    verificarDetalhesDoCliente();
  }, [id]);

  const propsInputNome = {
    type: "text",
    placeholder: "Nome",
    mudar: (e) => setNome(e.target.value),
  };
  const propsInputContacto = {
    type: "text",
    placeholder: "Contacto",
    mudar: (e) => setContacto(e.target.value),
  };

  const propsInputEndereco = {
    type: "text",
    placeholder: "Endereço",
    mudar: (e) => setEndereco(e.target.value),
  };

  const propsInputNuit = {
    type: "text",
    placeholder: "Nuit",
    mudar: (e) => setNuit(e.target.value),
  };

  const propsInputData = {
    type: "date",
    placeholder: "Data",
    mudar: (e) => setData(e.target.value),
  };

  const propsInputColab = {
    type: "text",
    placeholder: "Colaborador Associado",
    mudar: (e) => setColaborador(e.target.value),
  };

  return (
    <div className="flex flex-col justify-between min-h-screen">
      <div className="bg-blue-500 h-[150px]">
        <NavBar />
      </div>
      {loading ? (
        <div>
          <Loading />
        </div>
      ) :
      (
        <div>
          {mensagem && (
            <div className="text-center text-red-500 font-medium my-4">
              {mensagem}
            </div>
          )}
          {cadastrado ? (
            <div>
              <div className="text-center container mx-auto md:my-2 p-6 my-4 bg-gray-50 rounded-md shadow-md">
                <h1 className="text-green-600 text-lg font-extrabold lg:text-2xl md:text-2xl mb-4">
                  Cliente já cadastrado!
                </h1>
                <button onClick={() => {
                  navigate(-1)
                }} className="outline-none border-none px-6 py-2 bg-blue-500 text-white font-semibold rounded-md shadow hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2">
                  Voltar
                </button>
              </div>
            </div>
          ) : (
            <div className="flex justify-center flex-grow p-4">
              <div className="w-full max-w-4xl border py-6 rounded-xl bg-white shadow-md">
                <div className="w-[90%] lg:w-[60%] mx-auto flex flex-col">
                  <div className="mx-auto border rounded-xl bg-gray-50 m-2 p-2 py-4 w-full">
                    <h2 className="mx-auto text-[20px] lg:text-[25px] text-center">
                      Formulário de Clientes
                    </h2>
                  </div>
                  <div className="m-1 sm:w-[98%]">
                    <InputAdd {...propsInputNome} />
                  </div>
                  <div className="flex flex-wrap gap-2 m-1">
                    <div className="w-full sm:w-[49%]">
                      <InputAdd {...propsInputContacto} />
                    </div>
                    <div className="w-full sm:w-[49%]">
                      <InputAdd {...propsInputEndereco} />
                    </div>
                  </div>
                  <div className="flex flex-wrap gap-2 m-1">
                    <div className="w-full sm:w-[99%]">
                      <InputAdd {...propsInputNuit} />
                    </div>
                  </div>
                  <div className="flex flex-wrap gap-2 m-1">
                    <div className="w-full sm:w-[49%]">
                      <InputAdd {...propsInputData} />
                    </div>
                    <div className="w-full sm:w-[49%]">
                      <InputAdd {...propsInputColab} />
                    </div>
                  </div>
                  {cadastrando ? (
                        <button className="w-full mt-4 bg-blue-500 p-2 text-white rounded-lg">
                          <div className="flex justify-center items-center gap-1">
                            <span>Processando</span>
                            <LoaderCircle
                              strokeWidth={4}
                              size={18}
                              className={
                                cadastrando ? "animate-spin text-white" : ""
                              }
                            />
                          </div>
                        </button>
                      ) : (
                        <button
                          onClick={() => {
                            adicionarDadosCliente(); // Certifique-se de que esta função esteja corretamente definida
                          }}
                          className="w-full mt-4 bg-blue-500 p-2 text-white rounded-lg"
                        >
                          Cadastrar
                        </button>
                      )}
                </div>
              </div>
            </div>
          )}
        </div>
      )}
      <div className="bg-blue-500">
        <Footer />
      </div>
    </div>
  );
}
